<template>
    <v-dialog persistent v-model="dialog" width="50%">
        <v-card fluid>
            <v-card-title>Add park</v-card-title>
            <v-divider  class="ml-2 mr-2 mb-2"></v-divider>
            <v-card-text>
                <v-row cols="12" dense class="flex-row">
                    <v-col cols="2" offset="1" class="mt-1 pr-3">
                        <v-text-field v-model="parccode" label="Park code"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mt-1 pr-3 flex-row">
                        <v-btn small color="success" @click="$refs.get_parc_code.open('parccode')">
                            try and get...
                        </v-btn>
                        <div class="mt-1 ml-4">
                            <v-checkbox label="Test" v-model="isTest"></v-checkbox>
                        </div>
                    </v-col>        
                </v-row>
                <v-row cols="12" dense>
                    <v-col cols="3" offset="1" class="pr-3">
                        <v-text-field v-model="supplier" label="Ext. supplier Id" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pr-3">
                        <select_connector :selected_connection="connection" label="Connection" field="connection"  @updateData="updateData"/>
                    </v-col>                    
                </v-row>                       
                <v-row cols="12" dense>
                    <v-col cols="5" offset="1" class="pr-3">
                        <v-text-field v-model="name" label="Park name" dense></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pr-3">
                        <input_amount label="Margin" prefix="%" :amount="margin" field="margin" @updateData="updateData"/>
                    </v-col>           
                    <v-col cols="3" class="pr-3">
                        <select_margin_calculation label="Calculation method" field="calculationcode" :selected_calculationcode="calculationcode" @updateData="updateData"/>
                    </v-col>                
                </v-row>                
                <v-row cols="12" dense>
                    <v-col cols="5" offset="1" class="pr-3">
                        <select_eignlist :isClearable="true" field="eigncode" label="Host connected as (park) owner" @updateData="updateData"/>
                    </v-col>
                </v-row>                

            </v-card-text>
            <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions >
                <v-row cols="12" dense class="mt-2 mb-2">
                    <v-col cols="8" offset="1" class="pr-3 flex-row">
                    <v-icon v-if="error!==''" color="red" class="mr-2">mdi-alert-circle-outline</v-icon><div class="error">{{ error }}</div>
                </v-col>
                    <v-spacer></v-spacer>    
                <v-btn @click="closeDialog" color="primary" class="mr-2">
                    cancel
                </v-btn>                  
                <v-btn @click="saveParcData" color="success">
                    save
                </v-btn>     

                </v-row>
            </v-card-actions>
        </v-card>
        <get_parc_code ref="get_parc_code" @updateData="updateData" />
    </v-dialog>
</template>

<script>
    
    import input_amount from '@/components/huis/hspt/ui/input_amount.vue';
    import select_margin_calculation from '@/views/task/pp/select_margin_calculation.vue';
    import select_eignlist from "@/components/ui/selectors/select_eign.vue";
    import get_parc_code from "@/views/task/pp/get_parc_code.vue";
    import select_connector from '@/views/task/pp/select_connector.vue';

    export default {
        components: {
            input_amount,
            select_margin_calculation,
            select_eignlist,
            get_parc_code,
            select_connector
        },        
        data() {
            return {
                dialog: false,
                margin: '',
                calculationcode: 'rent',
                calculation_name: '', 
                calculation_explanation: '',
                calculationcodes: [],
                connection: 'Qenner',
                name: '',
                supplier: '',
                parccode: '',
                eigncode: '',
                error: '',        
                isTest: false        
            }
        },    
        methods: {
            open() {
                this.dialog = true      
                this.resetValues()          
            },                    
            closeDialog() {
                this.dialog = false;
                this.$emit('reload');
            },        
            updateData(data){
                console.log(data)
                if(Array.isArray(data)){
                    this[data[0].field] = data[0].value
                    this[data[1].field] = data[1].value
                    this[data[2].field] = data[2].value
                } else {
                    this[data.field] = data.value
                }
            },            
            toDutchNumberFormat(value) {
                // decimal seperator must be "," for input value
                if(value != null && value != '' && value != '0') {    
                    if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                        value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
                    } 
                    return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);
                } else {
                    return '0';
                }
            }, 
            resetValues () {
                this.margin = ''
                this.calculationcode = 'rent'
                this.calculation_name = ''
                this.calculation_explanation = ''
                this.calculationcodes = []
                this.connection = 'Qenner'
                this.name = ''
                this.supplier = ''
                this.parccode = ''
                this.eigncode = ''
                this.error = ''
                this.isTest = false
            },    
            validateValues(){
                this.error=''
                if(this.eigncode==='') this.error='A unique park must be connected to a host that is registered as a park'
                if(this.calcultioncode==='') this.error='There is no calculation method'
                if(this.margin==='') this.error='There is no margin. This park will be inactive and not accessible'
                if(this.name==='') this.error='A name is mandatory'
                if(this.connection==='') this.error='A connection type is mandatory (also see host)'
                if(this.supplier==='') this.error='A supplier code id is mandatory'
                if(this.parccode==='') this.error='A park code is mandatory in order to create bookings'                
                if(this.error!=='') return false 
                else return true
            }, 
            saveParcData(){

                if (!this.validateValues()) return

                this.$axios
                    .post("ares/json/ares/task/pp/addParkv2.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "addParc"
                        }, 
                        addParc: {
                            margin: this.toDutchNumberFormat(this.margin),
                            name: this.name,
                            parc_code: this.parccode,
                            supplier_id: this.supplier,
                            connection_id: this.connection,
                            calc_code: this.calculationcode,
                            calc_name: this.calculation_name,
                            eign_code: this.eigncode,
                            isTest: this.isTest
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            this.error = res.data.error.message
                        } else {
                            this.closeDialog()
                        }
                    })

            }
        }
    }
</script>

<style scoped>
.flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.text-color{
    color: black !important;
}
.error{
    background-color: transparent !important;
    color: red !important;
}
</style>